import React from 'react';

import {Button, Stack, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {Loading} from 'presentation/components/Loading/Loading';
import {SaveToCalendar} from 'presentation/pages/private/home/components';
import {translations} from 'presentation/translations-new';
import {ActionButtonsProps} from './types';
import {OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';

const {download, share} = translations['pt-br'].commons;

export function ActionButtons({
	isMobile,
	isPrinting,
	printContent,
	shareContent,
	calendarEvent,
	isSharing,
}: ActionButtonsProps) {
	const {colors} = useTheme();

	return (
		<Stack gap={1} direction={isMobile ? 'column' : 'row'}>
			<Stack className="remove-me" direction="row" gap={1}>
				<Button
					disabled={isPrinting}
					variant="outlined"
					endIcon={
						isPrinting ? (
							<Loading size={24} color="inherit" />
						) : (
							<Icon name="download" color={colors.brand.primary.blue} size={24} />
						)
					}
					fullWidth={isMobile}
					onClick={printContent}
					data-tag-id={OdontoBookingTaggingEnum.CLICK_BAIXAR_AGENDAMENTO}>
					{download}
				</Button>
				{isMobile ? (
					<Button
						disabled={isSharing}
						variant="outlined"
						endIcon={
							isSharing ? (
								<Loading size={24} color="inherit" />
							) : (
								<Icon
									name={'access-phone'}
									color={colors.brand.primary.blue}
									size={24}
								/>
							)
						}
						fullWidth={isMobile}
						onClick={shareContent}
						data-tag-id={OdontoBookingTaggingEnum.CLICK_COMPARTILHAR_AGENDAMENTO}>
						{share}
					</Button>
				) : null}
			</Stack>

			<SaveToCalendar
				dataTagId={OdontoBookingTaggingEnum.CLICK_SALVAR_NA_AGENDA}
				calendarEvent={calendarEvent}
			/>
		</Stack>
	);
}
